import { c as _c } from "react/compiler-runtime";
import { styled } from '@classify/react-core-components/styles';
import Typography from '@classify/react-core-components/Typography';
const PREFIX = 'CustomLi';
const classes = {
  root: `${PREFIX}-root`,
  label: `${PREFIX}-label`,
  bullet: `${PREFIX}-bullet`
};
const Root = styled('li')(/* istanbul ignore next */({
  theme: {
    spacing
  }
}) => ({
  [`&.${classes.root}`]: {
    marginBottom: spacing(1),
    listStyle: 'none',
    display: 'flex',
    alignItems: 'flex-start'
  },
  [`& .${classes.label}`]: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start'
  },
  [`& .${classes.bullet}`]: {
    marginRight: spacing(2)
  }
}));
export default function CustomLi(t0) {
  const $ = _c(7);
  const {
    children,
    icon,
    variant: t1,
    component: t2
  } = t0;
  const variant = t1 === undefined ? "body" : t1;
  const component = t2 === undefined ? "p" : t2;
  let t3;
  if ($[0] !== icon) {
    t3 = <span className={classes.bullet}>{icon}</span>;
    $[0] = icon;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== children || $[3] !== component || $[4] !== t3 || $[5] !== variant) {
    t4 = <Root className={classes.root}><Typography className={classes.label} variant={variant} component={component}>{t3}{children}</Typography></Root>;
    $[2] = children;
    $[3] = component;
    $[4] = t3;
    $[5] = variant;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}